/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBank from './blood-bank';
import BloodBankDetail from './blood-bank-detail';
import BloodBankUpdate from './blood-bank-update';
import BloodBankDeleteDialog from './blood-bank-delete-dialog';

const BloodBankRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBank />} />
    <Route path="new" element={<BloodBankUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankDetail />} />
      <Route path="edit" element={<BloodBankUpdate />} />
      <Route path="delete" element={<BloodBankDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankRoutes;
